import ClientReportInfo from './ClientReportInfo';
import React from 'react';
import { Box, LinearProgress, Skeleton, Stack, Typography } from '@mui/material';
import { reportNumber } from './clientPurchaseReportUtils';
import { reportPanelSx, reportSectionTitleSx } from './clientReportStyles';

export default function ClientsActivationSummary({ summary, status }) {
  const loading = status === 'loading';
  return (
    <Stack component="section" aria-label="Activation summary metrics" spacing={1.5} sx={reportPanelSx}>
      <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" spacing={0.5}>
        <Typography component="h2" sx={reportSectionTitleSx}>First purchase after registration<ClientReportInfo label="About first-purchase rates">Each rate uses clients with the full observation window. Pending clients need more time; — means no eligible clients.</ClientReportInfo></Typography>
        <Typography sx={{ color: '#64748b', fontSize: '0.8rem' }}>
          <Box component="strong" sx={{ color: '#0f172a' }}>{reportNumber(summary?.registrations)}</Box> registrations in this cohort
        </Typography>
      </Stack>
      {loading && <LinearProgress aria-label="Loading activation summary" />}
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'repeat(2, minmax(0, 1fr))', md: 'repeat(4, minmax(0, 1fr))' }, gap: 1 }}>
        {[1, 7, 14, 30].map((days) => {
          const metric = summary?.[`conversion_${days}d`];
          const hasRate = metric?.rate != null;
          return (
            <Box key={days} sx={{ p: { xs: 1.25, sm: 1.5 }, minWidth: 0, bgcolor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 2 }}>
              <Typography sx={{ color: '#475569', fontSize: '0.8rem', fontWeight: 700 }}>Within {days} day{days === 1 ? '' : 's'}</Typography>
              {loading && !metric ? <Skeleton width="65%" height={40} /> : (
                <Typography sx={{ my: 0.5, fontSize: { xs: '1.65rem', sm: '2rem' }, lineHeight: 1.2, fontWeight: 800, color: '#1d4ed8', fontVariantNumeric: 'tabular-nums', overflowWrap: 'anywhere' }}>
                  {hasRate ? `${reportNumber(metric.rate, 1)}%` : '—'}
                </Typography>
              )}
              <Typography sx={{ color: '#475569', fontSize: '0.75rem' }}>
                {metric ? (hasRate ? `${reportNumber(metric.converted)} of ${reportNumber(metric.eligible)} eligible` : 'No eligible clients yet') : 'Awaiting report data'}
              </Typography>
              {Number(metric?.pending_maturity) > 0 && (
                <Typography sx={{ color: '#92400e', fontSize: '0.75rem' }}>{reportNumber(metric.pending_maturity)} pending</Typography>
              )}
            </Box>
          );
        })}
      </Box>
    </Stack>
  );
}
